import { connect } from "react-redux";
import { redirectToAuthUrl } from "../_config/helper.config";
import I18 from "./atoms/i18";
import TextButton from "./atoms/text-button";
function LoginRequiredView({ community }) {
  return (
    <div className="UserWallPage flex flex-col items-center justify-center">
      <div className="text-center my-5">
        <I18>Login is required to view this page</I18>
      </div>
      <TextButton
        label="Login"
        onClick={(e) => {
          redirectToAuthUrl(community);
        }}
      />
    </div>
  );
}

const msp = (s) => ({ community: s.community });
export default connect(msp)(LoginRequiredView);
